<template>
  <section class="accordion">
    <header class="accordion__header" @click="$emit('try-opening', slug)">
      <div class="accordion__number">
        {{ number }}
      </div>
      <div class="accordion__title">
        {{ title }}
      </div>
      <div class="accordion__button">
        Change
        <img class="accordion__button-arrow" src="/app/themes/cliftoncoffee/dist/images/sub-arrow.png" />
      </div>
    </header>
    <div class="accordion__content" :style="contentStyle">
      <main ref="inner" class="accordion__main">
        <slot />
      </main> 
    </div>
  </section>
</template>

<script>
import Tile from './Tile'

export default {
  data() {
    return {
      contentHeight: 400,
    }
  },
  computed: {
    contentStyle () {
      if (this.open) {
        return 'height: ' + this.contentHeight + 'px;'
      } else {
        return ''
      }
    }
  },
  props: {
    slug: {
      type: String, 
      default: ''
    },
    number: {
      type:[Number, String], 
      default: "1"
    },
    title: {
      type: String, 
      default: "How do you drink your coffee?"
    },
    open: {
      type: Boolean, 
      default: false
    }
  },
  components: {
    Tile
  },
  watch: {
    open: {
      handler() {
        this.setHeight();
      }
    }
  },
  methods: {
    setHeight() {
      console.log('Setting height!!')
      this.contentHeight = this.$refs.inner.clientHeight
    }
  },
  mounted() {
    this.contentHeight = this.$refs.inner.clientHeight

    const $this = this;
    window.addEventListener('resize', function() {
      $this.setHeight()
    });
  }
}
</script>